export class PageMenu {
    constructor() {
        this.init();
    };

    init() {
        let pathname = window.location.pathname;
        let links = document.querySelectorAll('.men-col .nav-item a');
        if(links) {
            links.forEach(link => {
                if(link.getAttribute('href') == pathname) {
                    link.classList.add('active');
                    let dropdown = link.closest('.dropdown-menu');
                    if(dropdown) {
                        dropdown.classList.add('show');
                    }
                    let navitem = link.closest('li.dropdown.nav-item');
                    if(navitem) {
                        navitem.classList.add('show');
                    }
                }
            });
        }
    };
};
